/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  formatDate,
  getGroupedFlightOptions,
  getNewDate,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import { validateRescheduleFlightPriceApi } from '../../api/flightApi';
import {
  DATE_MONTH_DAY_FORMAT,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import OneWayResultCard from '../one-way/OneWayResultCard';
import NoSearchResults from '../one-way/NoSearchResults';
import ResultsFooter from '../one-way/ResultsFooter';

export default function RoundtripRescheduleSearchResultsPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { transactionId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const originCountryCodeRef = useRef('');
  const destinationCountryCodeRef = useRef('');
  const onwardAllSearchResultsRef = useRef([]);
  const returnAllSearchResultsRef = useRef([]);
  const [onwardSearchResults, setOnwardSearchResults] = useState([]);
  const [returnSearchResults, setReturnSearchResults] = useState([]);
  const [searchRequest, setSearchRequest] = useState(undefined);
  const [bookingError, setBookingError] = useState(undefined);
  const [selectedOnwardfare, setSelectedOnwardFare] = useState(undefined);
  const [selectedReturnfare, setSelectedReturnFare] = useState(undefined);
  const [selectedOnwardFlight, setSelectedOnwardFlight] = useState(undefined);
  const [selectedReturnFlight, setSelectedReturnFlight] = useState(undefined);

  const getGroupdFares = (flightOptions) => {
    flightOptions.forEach((fo) => {
      let fares = fo.recommendedflight[0].flightfare;
      fares = Array.isArray(fares) ? fares : [fares];
      fares.forEach((fare) => {
        const carrierList = [];
        const seatsList = [];
        const bagList = [];
        const weighlist = [];
        const bookingClassList = [];
        const airFreeTextList = [];
        fo.recommendedflight[0].flightlegs.forEach((leg) => {
          carrierList.push(leg.carrier);
          seatsList.push(leg.numseatsavailable);
          bagList.push(leg.bagweight);
          weighlist.push(leg.bagunit);
          bookingClassList.push(leg.bookingclass);
          if (leg.weather_origin !== '') {
            airFreeTextList.push(leg.weather_origin);
          }
        });
        let supplierName = fo.recommendedflight[0].supplier;
        if (isEmpty(supplierName)) {
          const isAmadeus = fo.recommendedflight[0].nextracustomstr
            .split(',')
            .some((word) => word.includes('AMADEUS'));
          if (isAmadeus) {
            supplierName = 'amadeus';
          }
        }
        fare.supplierName = supplierName;
        fare.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
        fare.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
        fare.flightCarrier = carrierList;
        fare.numseatsavailable = seatsList;
        fare.flightBagWeight = bagList;
        fare.flightBagUnit = weighlist;
        fare.bookingClass = bookingClassList;
        fare.airFreeText = airFreeTextList;
      });
    });
    let groupedFlightOptions = getGroupedFlightOptions(flightOptions);
    groupedFlightOptions = Object.values(groupedFlightOptions);
    const updatedGroupedOptions = [...groupedFlightOptions];
    updatedGroupedOptions.sort(
      (flightOption1, flightOption2) =>
        flightOption1.recommendedflight[0].flightfare[0].totalfq -
        flightOption2.recommendedflight[0].flightfare[0].totalfq,
    );
    return updatedGroupedOptions;
  };

  const groupFlightSearchResults = () => {
    if (
      state &&
      state.searchResponse &&
      state.searchResponse.flightjourneys &&
      Array.isArray(state.searchResponse.flightjourneys) &&
      state.searchResponse.flightjourneys.length > 0
    ) {
      let onwardflightOptions = Array.isArray(
        state.searchResponse.flightjourneys[0]?.flightoptions,
      )
        ? state.searchResponse.flightjourneys[0].flightoptions
        : [state.searchResponse.flightjourneys[0]?.flightoptions || []];
      let returnflightOptions = Array.isArray(
        state.searchResponse.flightjourneys[1]?.flightoptions,
      )
        ? state.searchResponse.flightjourneys[1].flightoptions
        : [state.searchResponse.flightjourneys[1]?.flightoptions || []];
      onwardflightOptions = getGroupdFares(onwardflightOptions);
      returnflightOptions = getGroupdFares(returnflightOptions);

      onwardAllSearchResultsRef.current = JSON.parse(
        JSON.stringify(onwardflightOptions),
      );
      returnAllSearchResultsRef.current = JSON.parse(
        JSON.stringify(returnflightOptions),
      );
      setOnwardSearchResults(onwardflightOptions);
      setReturnSearchResults(returnflightOptions);
      const sr = {
        ...state.searchRequest,
        journeytype: 'RoundTrip',
        originLocation:
          onwardflightOptions[0]?.recommendedflight[0]?.flightlegs[0]
            ?.origin_name || '',
        destinationLocation:
          onwardflightOptions[0]?.recommendedflight[0]?.flightlegs[0]
            ?.destination_name || '',
      };
      setSearchRequest(sr);
    }
  };

  useEffect(() => {
    if (state && state.searchResponse) {
      destinationCountryCodeRef.current =
        state.searchResponse.destinationcountrycode;
      originCountryCodeRef.current = state.searchResponse.origincountrycode;
      groupFlightSearchResults();
    }
  }, []);

  const handleOnwardFareSelection = (flight, fare) => {
    setSelectedOnwardFare(fare);
    setSelectedOnwardFlight(flight);
  };
  const handleReturnFareSelection = (flight, fare) => {
    setSelectedReturnFare(fare);
    setSelectedReturnFlight(flight);
  };

  const handleBook = async () => {
    try {
      setIsLoading(true);
      const agentId = getUserAgentId();
      const response = await validateRescheduleFlightPriceApi(
        agentId,
        transactionId,
        searchRequest.jtype,
        selectedOnwardfare.nextraflightkey,
        selectedReturnfare.nextraflightkey,
      );
      setIsLoading(false);
      if (
        response &&
        response.NextraPricingResponseV4 &&
        response.NextraPricingResponseV4.statuscode === '200'
      ) {
        const route =
          NAVIGATION_ROUTES.CHANGE_BOOKING.RESCHEDULE_BOOKING.replace(
            ':transactionId',
            transactionId,
          );
        navigate(route, {
          state: {
            repriseResponse: response.NextraPricingResponseV4,
            journeyType: 'roundtrip',
            changeBookingSector: state.changeBookingSector,
            airlinePNR: state.airlinePNR,
          },
        });
      } else {
        setBookingError({
          title: 'Failed to book',
          description: response?.ApiStatus?.Message || 'Pricing failed',
        });
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <section className="reschedule-booking-results-page">
      {bookingError && (
        <AppAlert
          variant="error"
          showIcon={false}
          title={bookingError.title}
          description={bookingError.description}
          onHide={() => setBookingError(undefined)}
        />
      )}
      <AppLoading isLoading={isLoading} />
      {searchRequest && (
        <section className="p-3 mb-5 app-container">
          <h3 className="change-booking-header mb-4">
            Change booking for transaction: {state.airlinePNR}
          </h3>
          <div className="reschedule-info search-info d-flex justify-content-between">
            <div className="search-info--item">
              <span className="search-info--item_heading">Journey</span>
              <span className="search-info--item_value">
                {searchRequest.jtype}
              </span>
            </div>
            <div className="search-info--item">
              <span className="search-info--item_heading">Destination</span>
              <span className="search-info--item_value primary-color">
                {`${searchRequest.origin} - ${searchRequest.destination}`}
              </span>
            </div>
            <div className="search-info--item">
              <span className="search-info--item_heading">Date</span>
              <span className="search-info--item_value">
                {formatDate(
                  getNewDate(searchRequest.jdate),
                  DATE_MONTH_DAY_FORMAT,
                )}
              </span>
            </div>
            <div className="search-info--item">
              <span className="search-info--item_heading">Date</span>
              <span className="search-info--item_value">
                {formatDate(
                  getNewDate(searchRequest.rdate),
                  DATE_MONTH_DAY_FORMAT,
                )}
              </span>
            </div>
            <div className="search-info--item">
              <span className="search-info--item_heading">Passengers</span>
              <span className="search-info--item_value">
                {parseInt(searchRequest.numadults, 10) +
                  parseInt(searchRequest.numchildren, 10) +
                  parseInt(searchRequest.numinfants, 10)}{' '}
                Passengers
              </span>
            </div>
          </div>
        </section>
      )}
      <div className="app-container d-flex">
        <div className="flex-1">
          {onwardSearchResults.map((row, index) => (
            <OneWayResultCard
              name="one_way_card"
              domint={state.searchResponse.domint}
              key={row.recommendedflight[0].nextraflightkey}
              flight={row.recommendedflight[0]}
              selectedFare={selectedOnwardfare}
              onFareSelection={handleOnwardFareSelection}
              journeyType="RoundTrip"
              searchRequest={searchRequest}
              onSelectForEmail={() => {}}
              flightsForEmail={[]}
              showInvoiceFare={false}
              index={index}
              isAmPmFormat={false}
              isOnward
              conversionRate={1}
              currencyOption="INR"
              onNavigateToBookingPage={() => {}}
              onShareViaEmail={() => {}}
              onShareViaWhatsapp={() => {}}
              fareInclusions={{}}
            />
          ))}
        </div>
        <div className="flex-1">
          {returnSearchResults.map((row, index) => (
            <OneWayResultCard
              name="one_way_card"
              domint={state.searchResponse.domint}
              key={row.recommendedflight[0].nextraflightkey}
              flight={row.recommendedflight[0]}
              selectedFare={selectedReturnfare}
              onFareSelection={handleReturnFareSelection}
              journeyType="RoundTrip"
              searchRequest={searchRequest}
              onSelectForEmail={() => {}}
              flightsForEmail={[]}
              showInvoiceFare={false}
              index={index}
              isAmPmFormat={false}
              isOnward={false}
              conversionRate={1}
              currencyOption="INR"
              onNavigateToBookingPage={() => {}}
              onShareViaEmail={() => {}}
              onShareViaWhatsapp={() => {}}
              fareInclusions={{}}
            />
          ))}
        </div>
        {returnSearchResults.length === 0 &&
          onwardSearchResults.length === 0 && (
            <NoSearchResults message="Please change your filter criteria and try again" />
          )}
      </div>
      {(selectedOnwardfare || selectedReturnfare) && (
        <ResultsFooter
          journeyType="roundtrip"
          selectedFare={{
            onward: selectedOnwardfare,
            return: selectedReturnfare,
          }}
          selectedFlight={{
            onward: selectedOnwardFlight,
            return: selectedReturnFlight,
          }}
          searchRequest={searchRequest}
          onBook={handleBook}
          conversionRate={1}
          currencyOption="INR"
          selectedClassInfo={{}}
        />
      )}
    </section>
  );
}
